module.exports = __webpack_public_path__ + "img/meghpakhi-banner.09fdc75f.jpg";